import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { Button } from '@mui/material';
import { CircleCheckBig } from 'lucide-react';

import { useVerifySharingInvitation } from '../../hooks/tanstack/useOrganizationHook';
import {
  useCustomNavigate,
  useGetRouteParams,
} from '../../hooks/tanstack/useUtilsHook';
import routes from '../../routes';

const VerificationSuccess = () => {
  const navigate = useNavigate();

  const handleContinue = () => {
    navigate('/login?type=login_by_link');
  };

  return (
    <div className="flex items-center bg-primary-dark-blue h-svh justify-center py-20">
      <div className="text-white flex flex-col items-center gap-4 text-center">
        <CircleCheckBig size={100} />
        <p className="text-[40px] font-semibold">Welcome</p>
        <p className="max-w-[550px] text-lg">
          Your account isn't fully set up yet, so you'll be directed to the Log
          in by Link page to access the project and set your password.
        </p>
        <Button
          onClick={handleContinue}
          size="large"
          style={{
            backgroundColor: '#B8341B',
            color: 'white',
            padding: '8px 32px',
          }}
        >
          Continue
        </Button>
      </div>
    </div>
  );
};

const VerificationFailed = () => (
  <div className="flex items-center bg-primary-dark-blue h-svh justify-center">
    <div className="text-white flex flex-col items-center gap-4 text-center">
      <h1 className="text-[48px] font-bold ">Oops!!!</h1>
      <img src="/images/time.png" width={132} height={132} />
      <p className="text-2xl font-bold">Sharing Verification Failed!</p>
      <p>
        We're sorry, but it seems the verification link has expired or invalid.
      </p>
    </div>
  </div>
);

const SharingInvitationVerification = () => {
  const { token, orgId, projectId } = useGetRouteParams();

  const navigate = useCustomNavigate();

  const [status, setStatus] = useState<'success' | 'pending' | 'failed' | null>(
    null
  );

  const { mutate: verifySharingInvitation } = useVerifySharingInvitation({
    onSuccess: (data) => {
      localStorage.setItem(
        'user',
        JSON.stringify({
          id: data.user.id,
        })
      );
      navigate(routes.projects.model.index, {
        org_id: orgId,
        project_id: projectId,
      });
    },
    onError() {
      setStatus('failed');
    },
  });

  useEffect(() => {
    setStatus('pending');
  }, []);

  useEffect(() => {
    if (status === 'pending' && token) {
      verifySharingInvitation({
        orgId,
        projectId,
        data: {
          token: token as string,
        },
      });
    }
  }, [status]);

  if (status === 'failed') {
    return <VerificationFailed />;
  }

  if (status === 'success') {
    return <VerificationSuccess />;
  }

  return <div className="flex h-screen bg-primary-dark-blue " />;
};

export default SharingInvitationVerification;
